// extracted by mini-css-extract-plugin
module.exports = {"ReadingTime":"ReadingTime_ReadingTime__F0JZM"};